import ApiService from '@/common/api.service'
import AuthService from '@/common/auth.service'
import PromoService from '@/common/promo.service'
import {
  CONFIRMATION_GENERATOR_ID,
  EMAIL_CONFIRMATION_GENERATOR_ID
} from '@/common/config'
import {
  USER_LOGIN,
  USER_EMAIL_LOGIN,
  USER_LOGOUT,
  SEND_CONFIRMATION_CODE,
  CONFIRM_COMMUNICATION,
  USER_INFO,
  USER_CONSENT,
  UPDATE_USER,
  UPDATE_USER_CONSENT,
  REG_STATUS,
  GET_PROMO,
  SET_PROMO,
  UPLOAD_CHECK,
  GET_CHECKS,
  UPLOAD_COUPON,
  CHECK_USER_AUTH,
  SET_USER_QUESTIONNAIRE
} from './actions.type'
import {
  SET_USER_AUTH,
  SET_USER,
  PURGE_USER_AUTH,
  SET_ERROR,
  PURGE_ERRORS,
  SAVE_PROMO
} from './mutations.type'

const state = {
  errors: null,
  user: AuthService.getUser() || {},
  isUserAuthenticated: !!AuthService.getUser(),
  promo: PromoService.getPromo() || ''
}

const getters = {
  currentUser (state) {
    return state.user
  },
  isUserAuthenticated (state) {
    return state.isUserAuthenticated
  },
  currentPromo (state) {
    return state.promo
  }
}

const actions = {
  [USER_LOGIN] (context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.call('login', {
        'userData': {
          'phone': credentials.phone
        }
      })
        .then(({ data }) => {
          if (data.success) {
            context.commit(SET_USER_AUTH, data.userData)
            resolve(data.userData)
          } else {
            if (data.errorCode === 502) {
              ApiService.call('registration', {
                'userData': {
                  'phone': credentials.phone
                }
              })
                .then(({ data }) => {
                  if (data.success) {
                    context.commit(SET_USER_AUTH, data.userData)
                    resolve(data.userData)
                  } else {
                    context.commit(SET_ERROR, data.warnings)
                    reject(data)
                  }
                })
            } else {
              context.commit(SET_ERROR, data.warnings)
              reject(data)
            }
          }
        })
        .catch((error) => {
          reject(error)
          // alert(error.message)
        })
    })
  },
  [USER_EMAIL_LOGIN] (context, email) {
    return new Promise((resolve, reject) => {
      ApiService.call('login', {
        'userData': {
          'email': email
        }
      })
        .then(({data}) => {
          if (data.success) {
            resolve(data.userData)
          } else {
            reject(data)
          }
        })
    })
  },
  [USER_LOGOUT] (context) {
    context.commit(PURGE_USER_AUTH)
  },
  [SEND_CONFIRMATION_CODE] (context, params) {
    return new Promise((resolve, reject) => {
      let user = AuthService.getUser()
      ApiService
        .call('generateticket', {
          'generatorId': params.type === 'sms' ? CONFIRMATION_GENERATOR_ID : EMAIL_CONFIRMATION_GENERATOR_ID,
          'identifierId': params.id,
          'userData': {
            'userId': user.userId,
            'secretKey': user.secretKey
          }
        })
        .then(({data}) => {
          if (data.success) {
            resolve(data)
          } else {
            context.commit(SET_ERROR, data.warnings)
            reject(data)
          }
        })
    })
  },
  [CONFIRM_COMMUNICATION] (context, params) {
    return new Promise((resolve, reject) => {
      let user = AuthService.getUser()
      if (typeof params.user !== 'undefined') user = params.user
      ApiService
        .call('confirmticket', {
          'generatorId': params.type === 'sms' ? CONFIRMATION_GENERATOR_ID : EMAIL_CONFIRMATION_GENERATOR_ID,
          'value': params.code,
          'identifierId': params.id,
          'userData': {
            'userId': user.userId,
            'secretKey': user.secretKey
          }
        })
        .then(({data}) => {
          if (data.success) {
            resolve(data)
          } else {
            context.commit(SET_ERROR, data.warnings)
            reject(data)
          }
        })
    })
  },
  [USER_INFO] (context, emailUser) {
    let user = emailUser || AuthService.getUser()
    return new Promise((resolve, reject) => {
      ApiService
        .call('currentuser', {
          'userData': {
            'userId': user.userId,
            'secretKey': user.secretKey
          }
        })
        .then(({data}) => {
          if (data.success) {
            context.commit(SET_USER, data.userData)
            // context.commit(SET_USER_AUTH, user)
            resolve(data.userData)
          } else {
            reject(data)
            context.commit(SET_ERROR, data.warnings)
          }
        })
    })
  },
  [USER_CONSENT] (context) {
    let user = AuthService.getUser()
    return new Promise((resolve, reject) => {
      ApiService
        .data('GetUserConsent', { 'SiteUserId': user.userId })
        .then(({data}) => {
          resolve(data[0])
        })
    })
  },
  [UPDATE_USER] (context, userData) {
    let user = AuthService.getUser()
    return new Promise((resolve, reject) => {
      ApiService
        .call('edituser', {
          'userData': Object.assign(userData['userData'], {
            'userId': user.userId,
            'secretKey': user.secretKey
          })
        })
        .then(({data}) => {
          if (data.success) {
            resolve(data.userData)
          } else {
            reject(data)
            context.commit(SET_ERROR, data.warnings)
          }
        })
    })
  },
  [UPDATE_USER_CONSENT] (context, params) {
    let user = AuthService.getUser()
    params['userConsentData']['userId'] = user.userId
    return new Promise((resolve, reject) => {
      ApiService
        .call('userconsent', params)
        .then(({data}) => {
          if (data.success) {
            resolve(data.userData)
          } else {
            reject(data)
            context.commit(SET_ERROR, data.warnings)
          }
        })
    })
  },
  [REG_STATUS] (context) {
    let user = AuthService.getUser()
    return new Promise((resolve, reject) => {
      ApiService
        .data('GetRegStatus', { 'SiteUserId': user.userId })
        .then(({data}) => {
          resolve(data[0])
        })
    })
  },
  [GET_PROMO] (context) {
    return new Promise((resolve, reject) => {
      ApiService
        .data('GetCurrentPromoList')
        .then(({data}) => {
          resolve(data)
        })
    })
  },
  [SET_PROMO] (context, action) {
    context.commit(SAVE_PROMO, action)
    let user = AuthService.getUser()
    return new Promise((resolve, reject) => {
      ApiService
        .call('addUserEvent', {
          'userData': {
            'userId': user.userId,
            'secretKey': user.secretKey
          },
          campaign: {
            event: {
              id: action.Id
            }
          }
        })
        .then(({ data }) => {
          resolve(data)
        })
    })
  },
  [UPLOAD_CHECK] (context, params) {
    let user = AuthService.getUser()
    return new Promise((resolve, reject) => {
      ApiService
        .call('submitreceiptqrcode', {
          'userData': {
            'userId': user.userId,
            'secretKey': user.secretKey
          },
          ...params
        })
        .then(({data}) => {
          if (data.success) {
            resolve(data)
          } else {
            reject(data)
            context.commit(SET_ERROR, data.warnings)
          }
        })
        .catch((response) => {
          reject(response)
          alert(response.message)
        })
    })
  },
  [GET_CHECKS] (context) {
    let user = AuthService.getUser()
    return new Promise((resolve, reject) => {
      ApiService
        .data('GetReceipts', { 'SiteUserId': user.userId })
        .then(({ data }) => {
          resolve(data)
        })
    })
  },
  [UPLOAD_COUPON] (context, code) {
    let user = AuthService.getUser()
    return new Promise((resolve, reject) => {
      ApiService
        .call('acceptcoupon', {
          'userData': {
            'userId': user.userId,
            'secretKey': user.secretKey
          },
          'couponData': {
            'value': code,
            'typeId': 'e3494aec-f806-460a-a82c-6b9da6254ea0',
            'siteCampaignEventId': '1e5b2df1-0a85-47d7-8bfb-4d2cabb63efd',
            'name': 'Купон'
          }
        })
        .then(({data}) => {
          if (data.success) {
            resolve(data)
          } else {
            reject(data)
            context.commit(SET_ERROR, data.warnings)
          }
        })
    })
  },
  [CHECK_USER_AUTH] (context) {
    let user = AuthService.getUser()
    if (user) {
      ApiService.call('currentuser', {
        'userData': {
          'userId': user.userId,
          'secretKey': user.secretKey
        }
      })
        .then(({data}) => {
          if (data.success) {
            context.commit(SET_USER, data.userData)
            context.commit(SET_USER_AUTH, user)
          } else {
            context.commit(PURGE_USER_AUTH)
          }
        })
    } else {
      context.commit(PURGE_USER_AUTH)
    }
  },
  [SET_USER_QUESTIONNAIRE] (context, questionnaire) {
    let user = AuthService.getUser()
    return new Promise((resolve, reject) => {
      ApiService
        .call('setuserquestionnaire', {
          'userData': {
            'userId': user.userId,
            'secretKey': user.secretKey
          },
          ...questionnaire
        })
        .then(({data}) => {
          if (data.success) {
            resolve(data)
          } else {
            reject(data)
            context.commit(SET_ERROR, data.warnings)
          }
        })
    })
  }
}

const mutations = {
  [SET_ERROR] (state, error) {
    state.errors = error
  },
  [PURGE_ERRORS] (state) {
    state.errors = {}
  },

  [SET_USER_AUTH] (state, user) {
    state.isUserAuthenticated = true
    AuthService.saveUser(user)
  },
  [SET_USER] (state, user) {
    state.user = user
  },
  [PURGE_USER_AUTH] (state) {
    state.isUserAuthenticated = false
    state.user = {}
    state.errors = {}
    AuthService.destroyUser()
    PromoService.removePromo()
  },

  [SAVE_PROMO] (state, action) {
    state.promo = action
    PromoService.setPromo(action)
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/user.module.js